import api from '@/api/api.js'
import base from '@/api/base.js'

export default{
  api,
  base
}